import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchLotteryRepresentatives = (retailerId) => {
  const { url } = DepsService.rest.widgets.lotteryRepresentatives;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/lottery-representatives.api.js